import pagination from '../../utils/pagination'
import {
  TEMPLATES_BATCH_DELETE_REQUEST, TEMPLATES_BATCH_DELETE_SUCCESS, TEMPLATES_BATCH_DELETE_FAILURE,
  TEMPLATES_FETCH_MANY_REQUEST, TEMPLATES_FETCH_MANY_SUCCESS, TEMPLATES_FETCH_MANY_FAILURE,
  TEMPLATES_FETCH_REQUEST, TEMPLATES_FETCH_SUCCESS, TEMPLATES_FETCH_FAILURE,
  TEMPLATES_SAVE_REQUEST, TEMPLATES_SAVE_SUCCESS, TEMPLATES_SAVE_FAILURE,

  EMPTY_TEMPLATES,
  CLEAR_ERRORS
} from './types'

export default {
  [TEMPLATES_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [TEMPLATES_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [TEMPLATES_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [TEMPLATES_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [TEMPLATES_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [TEMPLATES_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [TEMPLATES_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [TEMPLATES_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [TEMPLATES_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [TEMPLATES_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [TEMPLATES_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [TEMPLATES_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_TEMPLATES] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
